/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Svg,
  Path,
  Font,
} from "@react-pdf/renderer";
import moment from "moment";
import tickimg from "../../Assets/tickimg.png";
import kalamFont from "../../font/Kalam-Light.ttf";
import LatoBold from "../../font/Lato-Bold.ttf";
import LatoRegular from "../../font/Lato-Regular.ttf";
import "../../font/registerPatrickHandAndCaveatPdf";
import {
  arkansasInspectionColumns,
  getArkansasPointStatus,
} from "./arkansasInspectionData";
import { handDrawnCirclePath } from "../../utils/handDrawnCircle";

Font.register({ family: "kalamFont", format: "truetype", src: kalamFont });
Font.register({ family: "LatoBold", format: "truetype", src: LatoBold });
Font.register({ family: "LatoRegular", format: "truetype", src: LatoRegular });

const styles = StyleSheet.create({
  body: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 28,
    paddingRight: 44,
    backgroundColor: "white",
    color: "#1a1a1a",
  },
  header: {
    backgroundColor: "#1d1d1d",
    flexDirection: "row",
    alignItems: "center",
    padding: "22px 56px",
    marginTop: -16,
    marginLeft: -28,
    marginRight: -44,
  },
  rasierText: {
    color: "white",
    fontSize: 26,
    fontFamily: "LatoBold",
    letterSpacing: 2,
    marginRight: 26,
  },
  rasierPara: {
    color: "white",
    fontSize: 13,
    textTransform: "uppercase",
    letterSpacing: 1.6,
  },
  bodyWrap: {
    paddingHorizontal: 28,
    paddingTop: 20,
  },
  columns: {
    flexDirection: "row",
  },
  colLeft: {
    width: "50%",
    paddingRight: 18,
  },
  colRight: {
    width: "50%",
    paddingLeft: 18,
  },
  title: {
    fontSize: 19,
    fontFamily: "LatoBold",
    letterSpacing: 1,
    marginBottom: 10,
    marginTop: -5,
  },
  note: {
    fontSize: 9,
    fontFamily: "LatoBold",
    lineHeight: 1.4,
    color: "#7a7a7a",
    textTransform: "uppercase",
    marginBottom: 12,
    letterSpacing: 1.8,
  },
  pointsHeader: {
    flexDirection: "row",
    alignItems: "center",
    color: "#8a8a8a",
    paddingBottom: 6,
  },
  pointsHeaderLabel: {
    flex: 1,
    fontSize: 9,
    textTransform: "uppercase",
    color: "#8a8a8a",
  },
  pointsHeaderOpt: {
    width: 32,
    fontSize: 8,
    textAlign: "center",
    textTransform: "uppercase",
    color: "#8a8a8a",
  },
  pointsHeaderDark: {
    color: "#1a1a1a",
  },
  pointRow: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: 22,
  },
  pointLabel: {
    flex: 1,
    flexDirection: "row",
  },
  pointNum: {
    width: 16,
    fontSize: 9,
    color: "#8a8a8a",
    marginTop: 1.5,
  },
  pointText: {
    flex: 1,
    fontSize: 10,
    fontFamily: "LatoBold",
    color: "#1a1a1a",
  },
  checkboxCell: {
    width: 32,
    alignItems: "center",
    justifyContent: "center",
  },
  checkbox: {
    width: 12,
    height: 12,
    borderWidth: 1,
    borderColor: "#1a1a1a",
    alignItems: "center",
    justifyContent: "center",
  },
  checkboxTick: {
    width: 10,
  },
  resultBox: {
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: "#1a1a1a",
    padding: "16px 14px",
    marginTop: 30,
  },
  resultLine: {
    flexDirection: "row",
    alignItems: "center",
  },
  resultTitle: {
    fontSize: 12,
    fontFamily: "LatoRegular",
    marginRight: 62,
    marginBottom: 4,
  },
  resultOption: {
    position: "relative",
    width: 52,
    height: 22,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 8,
  },
  resultOptionText: {
    fontSize: 12,
    fontFamily: "LatoBold",
    marginBottom: 3,
    marginLeft: 4,
  },
  handCircle: {
    position: "absolute",
    top: -15,
    left: -16,
    width: 84,
    height: 44,
  },
  resultNote: {
    fontSize: 8,
    marginTop: -7,
  },
  resultSub: {
    fontSize: 7.5,
    marginTop: 10,
  },
  partnerFields: {
    marginTop: 18,
  },
  partnerRow: {
    flexDirection: "row",
    marginTop: 18,
  },
  inspectorRow: {
    flexDirection: "row",
    marginTop: 10,
  },
  field: {
    flex: 1,
    marginRight: 24,
  },
  fieldLast: {
    flex: 1,
  },
  fieldWide: {
    flex: 1.6,
    marginRight: 24,
  },
  fieldNarrow: {
    flex: 0.6,
  },
  fieldValue: {
    fontSize: 12,
    minHeight: 16,
    paddingLeft: 3,
    marginBottom: -2,
  },
  fieldRule: {
    borderBottomWidth: 1,
    borderBottomColor: "#1a1a1a",
  },
  fieldCaption: {
    fontSize: 8.5,
    color: "#1a1a1a",
    paddingTop: 4,
    textTransform: "uppercase",
  },
  inspectorSection: {
    backgroundColor: "#e6e7e9",
    marginTop: 20,
    paddingTop: 12,
    paddingBottom: 12,
    paddingHorizontal: 28,
  },
  inspectorHeading: {
    fontSize: 11,
    fontFamily: "LatoBold",
    textTransform: "uppercase",
    marginBottom: 0,
  },
  bottomNotes: {
    textAlign: "center",
    paddingHorizontal: 60,
    marginTop: 3,
  },
  bottomNotePara: {
    fontSize: 9,
    color: "#1a1a1a",
    marginTop: 2,
  },
});

const HandCircle = () => (
  <Svg style={styles.handCircle} viewBox="0 0 112 73">
    <Path
      d={handDrawnCirclePath}
      stroke="#000000"
      strokeWidth={5}
      strokeLinecap="round"
      fill="none"
    />
  </Svg>
);

const PdfCheckbox = ({ checked }) => (
  <View style={styles.checkboxCell}>
    <View style={styles.checkbox}>
      {checked ? <Image style={styles.checkboxTick} source={tickimg} /> : null}
    </View>
  </View>
);

const PointRow = ({ point, status }) => (
  <View style={styles.pointRow}>
    <View style={styles.pointLabel}>
      <Text style={styles.pointNum}>{point.number}</Text>
      <Text style={styles.pointText}>{point.label}</Text>
    </View>
    <PdfCheckbox checked={status.pass} />
    <PdfCheckbox checked={status.fail} />
  </View>
);

const Field = ({ label, value, style, handwritingStyle }) => (
  <View style={style}>
    <Text style={[styles.fieldValue, handwritingStyle].filter(Boolean)}>
      {value || " "}
    </Text>
    <View style={styles.fieldRule} />
    <Text style={styles.fieldCaption}>{label}</Text>
  </View>
);

function UberArkansasCertificateDownload({
  checksData,
  reportData,
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) {
  const handwritingStyle = { fontFamily: handwritingFont };
  const finalStatus = reportData?.finalStatus;

  return (
    <div className="App">
      <PDFDownloadLink
        wrap={false}
        document={
          <Document>
            {/* Auto-height page (A3 width) so the certificate fits on one page */}
            <Page
              size={{ width: 841.89 }}
              style={[styles.body, { minHeight: 1190.55 }]}
              wrap={false}
            >
              <View style={styles.header}>
                <Text style={styles.rasierText}>RASIER</Text>
                <Text style={styles.rasierPara}>
                  FOR USE BY DRIVER-PARTNERS ON THE UBER PLATFORM ONLY
                </Text>
              </View>

              <View style={styles.bodyWrap}>
                <View style={styles.columns}>
                  {/* Left column */}
                  <View style={styles.colLeft}>
                    <Text style={styles.title}>ANNUAL VEHICLE INSPECTION</Text>
                    <Text style={styles.note}>
                      {"NOTE: THIS INSPECTION MUST BE COMPLETED OR\n" +
                        "SUPERVISED BY AN AUTOMOTIVE SERVICE\n" +
                        "EXCELLENCE (ASE) CERTIFIED MECHANIC."}
                    </Text>
                    <View style={styles.pointsHeader}>
                      <Text style={styles.pointsHeaderLabel}>
                        INSPECTION POINT
                      </Text>
                      <Text style={styles.pointsHeaderOpt}>PASS</Text>
                      <Text style={styles.pointsHeaderOpt}>FAIL</Text>
                    </View>
                    {arkansasInspectionColumns[0].map((point) => (
                      <PointRow
                        key={point.number}
                        point={point}
                        status={getArkansasPointStatus(
                          checksData,
                          point.number - 1
                        )}
                      />
                    ))}
                  </View>

                  {/* Right column */}
                  <View style={styles.colRight}>
                    <View style={[styles.pointsHeader, { marginTop: -5, paddingBottom: 12 }]}>
                      <Text style={[styles.pointsHeaderLabel, styles.pointsHeaderDark]}>
                        INSPECTION POINT
                      </Text>
                      <Text style={[styles.pointsHeaderOpt, styles.pointsHeaderDark]}>
                        PASS
                      </Text>
                      <Text style={[styles.pointsHeaderOpt, styles.pointsHeaderDark]}>
                        FAIL
                      </Text>
                    </View>
                    {arkansasInspectionColumns[1].map((point) => (
                      <PointRow
                        key={point.number}
                        point={point}
                        status={getArkansasPointStatus(
                          checksData,
                          point.number - 1
                        )}
                      />
                    ))}

                    <View style={styles.resultBox}>
                      <View style={styles.resultLine}>
                        <Text style={styles.resultTitle}>
                          VEHICLE INSPECTION:
                        </Text>
                        <View style={styles.resultOption}>
                          {finalStatus === "pass" ? <HandCircle /> : null}
                          <Text style={styles.resultOptionText}>PASS</Text>
                        </View>
                        <View style={styles.resultOption}>
                          {finalStatus === "fail" ? <HandCircle /> : null}
                          <Text style={styles.resultOptionText}>FAIL</Text>
                        </View>
                      </View>
                      <Text style={styles.resultNote}>(Please circle)</Text>
                      <Text style={styles.resultSub}>
                        Must pass all inspection points to pass vehicle
                        inspection.
                      </Text>
                    </View>
                  </View>
                </View>

                {/* Partner fields */}
                <View style={styles.partnerFields}>
                  <View style={styles.partnerRow}>
                    <Field
                      label="Partner Name"
                      value={
                        reportData &&
                        `${reportData?.Username || ""} ${
                          reportData?.UserlastName === null
                            ? ""
                            : reportData?.UserlastName || ""
                        }`.trim()
                      }
                      style={styles.fieldWide}
                      handwritingStyle={handwritingStyle}
                    />
                    <Field
                      label="Email Address"
                      value={reportData && reportData?.Useremail}
                      style={styles.fieldLast}
                      handwritingStyle={handwritingStyle}
                    />
                  </View>
                  <View style={styles.partnerRow}>
                    <Field
                      label="Partner Signature"
                      value=" "
                      style={styles.fieldWide}
                      handwritingStyle={handwritingStyle}
                    />
                    <Field
                      label="Partner Phone Number"
                      value={reportData && reportData?.Userphone}
                      style={styles.field}
                      handwritingStyle={handwritingStyle}
                    />
                    <Field
                      label="Date"
                      value={moment(
                        new Date(reportData && reportData?.reviewedDate)
                      ).format("MM/ DD /YYYY")}
                      style={styles.fieldNarrow}
                      handwritingStyle={handwritingStyle}
                    />
                  </View>
                </View>
              </View>

              {/* Inspector gray section */}
              <View style={styles.inspectorSection}>
                <Text style={styles.inspectorHeading}>
                  TO BE COMPLETED BY INSPECTOR
                </Text>

                <View style={styles.inspectorRow}>
                  <Field
                    label="Name of Inspection Location"
                    value="Chex Inc."
                    style={[styles.field, { flex: 0.35 }]}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Address of Inspection Location"
                    value={reportData && reportData?.stateAddress}
                    style={[styles.fieldLast, { flex: 0.65 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <View style={styles.inspectorRow}>
                  <Field
                    label="License Plate #"
                    value={reportData && reportData?.licensePlateNumber}
                    style={[styles.field, { flex: 0.35 }]}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="VIN #"
                    value={reportData && reportData?.vin}
                    style={[styles.field, { flex: 0.4 }]}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Vehicle Mileage"
                    value={reportData && reportData?.milage}
                    style={[styles.fieldLast, { flex: 0.25 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <View style={styles.inspectorRow}>
                  <Field
                    label="Vehicle Make"
                    value={reportData && reportData?.make}
                    style={[styles.field, { flex: 0.35 }]}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Vehicle Model"
                    value={reportData && reportData?.model}
                    style={[styles.field, { flex: 0.45 }]}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Vehicle Year"
                    value={reportData && reportData?.year}
                    style={[styles.fieldLast, { flex: 0.2 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <View style={styles.inspectorRow}>
                  <View style={[styles.field, { flex: 0.55 }]}>
                    <View style={{ position: "relative" }}>
                      {reportData && reportData?.Inspectorsignature ? (
                        <Image
                          style={{ position: "absolute", bottom: 0, left: 60, width: 100, height: 40 }}
                          source={`${process.env.REACT_APP_AWS_S3_LINK}/${
                            reportData && reportData?.Inspectorsignature
                          }?x-request=xhr`}
                        />
                      ) : null}
                      <Text style={[styles.fieldValue, handwritingStyle]}>
                        {reportData && reportData?.Inspectorsignature
                          ? " "
                          : `${reportData?.Inspectorname || ""} ${
                              reportData?.InspectorlastName === null
                                ? ""
                                : reportData?.InspectorlastName || ""
                            }`.trim()}
                      </Text>
                    </View>
                    <View style={styles.fieldRule} />
                    <Text style={styles.fieldCaption}>
                      Signature of ASE-Certified Mechanic
                    </Text>
                  </View>
                  <Field
                    label="Inspection Date"
                    value={moment(
                      new Date(reportData && reportData?.reviewedDate)
                    ).format("MM/ DD /YYYY")}
                    style={[styles.fieldLast, { flex: 0.45 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>
              </View>

              <View style={styles.bottomNotes}>
                <Text style={styles.bottomNotePara}>
                  Please upload this form to your partners.uber.com account once
                  complete. This form expires up to one (1) year from the
                  inspection date.
                </Text>
                <Text style={styles.bottomNotePara}>
                  THIS FORM MAY ONLY BE USED BY DRIVER-PARTNERS ON THE UBER
                  PLATFORM.
                </Text>
              </View>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div
                className="certificate-download-button is-loading"
                aria-live="polite"
              >
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
}


const UberArkansasCertificateDownloadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "uber");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <UberArkansasCertificateDownload
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.uberVehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setOtherReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UberArkansasCertificateDownloadConnected);
